module.exports = __webpack_public_path__ + "img/biaoqing.15ff8c9e.png";